/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function()
 {  
  

  var arrayRandom = [1, 2, 3, 3, 5, 6, 7, 8];
  function random_item(items){
      return items[Math.floor(Math.random()*items.length)];   
  }
  $('.ProductForm__AddToCart').on("click",function(){
    var cartTimeout = setTimeout(function(){
      	var randomNum = random_item(arrayRandom);
    	$('.random__number').html(randomNum);
      	clearTimeout(cartTimeout)
    },1500)
  })
  
    var getProdVar;
    var selectedColor;
    var sizeArr = [];
    var quantityArr = [];
    var availableArray = [];
  	var availablerVariant;
  	var firstColorSelection = [];
    $(".selectedAvailabeVariant").each(function(i,v){
       availablerVariant = (JSON.parse($(v).html()));
    });
    var myTimeout = setTimeout(function(){
    	$('.variant-'+(availablerVariant.option1.toLowerCase())).children('.colorSelection').trigger('click');
      	clearTimeout(myTimeout)
    },500);
  	
  	//$('.variant-'+(availablerVariant.option1.toLowerCase())).find('input').trigger('change');
    $(".productVariantsCheck").each(function(i,v){
      	getProdVar = JSON.parse($(v).html());
    });
    if(getProdVar && getProdVar.length){
      for(var i = 0; i < getProdVar.length; i++){
        if(getProdVar[i].available){
          availableArray.push(getProdVar[i]);
          firstColorSelection.push(getProdVar[i].option1);

        }
      }
      firstColorSelection = uniqueArray(firstColorSelection);
      $('.commonColorValue').removeClass('instock').addClass("outofstock");
      $('.commonColorValue').find('.sold__img').remove();
      $('.commonColorValue').find('.ColorSwatch').append('<img class="sold__img" src="//cdn.shopify.com/s/files/1/0407/0906/2822/t/7/assets/cross-out.png" alt="Sold Out">')
      $.each(firstColorSelection,function(i,v){
        $('.variant-'+(firstColorSelection[i].toLowerCase())).removeClass('outofstock').addClass("instock");
        $('.variant-'+(firstColorSelection[i].toLowerCase())).find('.sold__img').remove();
      });
      $(".commonVariants").removeClass("instock")	;
      $(".commonVariants").removeClass("outofstock");

      $('.commonInput').off('click').on('click',selectProdVariant);
      $('.colorSelection').off('click').on('click',colorSelectionfun);
      $('.instock').eq(2).trigger("click");
    }
    function colorSelectionfun(){
      selectedColor = $(this).val();
	  sizeArr = [];
      quantityArr = [];
      for(var i = 0; i < availableArray.length; i++){
        if((availableArray[i].title).includes(selectedColor)){
          sizeArr.push(availableArray[i].option2)
        }
      }
      sizeArr = uniqueArray(sizeArr);
      $('.Size').removeClass("instock").addClass("outofstock");
      $('.Size').find('.sold__img').remove();
      $('.Size').find('.SizeSwatch').append('<img class="sold__img" src="//cdn.shopify.com/s/files/1/0407/0906/2822/t/7/assets/cross-out.png" alt="Sold Out">')
      $.each(sizeArr,function(i,v){
        $('.variant-'+(sizeArr[i].toLowerCase())).removeClass('outofstock').addClass("instock");
        $('.variant-'+(sizeArr[i].toLowerCase())).find('.sold__img').remove();
      });


      for(var i = 0; i < availableArray.length; i++){
        if((availableArray[i].title).includes(selectedColor)){
          quantityArr.push(availableArray[i].option3)
        }
      }
      quantityArr = uniqueArray(quantityArr);
      $('.Quantity').removeClass("instock").addClass("outofstock");
      $('.Quantity').find('.sold__img').remove();
      $('.Quantity').find('.SizeSwatch').append('<img class="sold__img" src="//cdn.shopify.com/s/files/1/0407/0906/2822/t/7/assets/cross-out.png" alt="Sold Out">')
      $.each(quantityArr,function(i,v){
        $('.variant-'+(quantityArr[i].split(' ').join('-').toLowerCase())).removeClass('outofstock').addClass("instock");
        $('.variant-'+(quantityArr[i].split(' ').join('-').toLowerCase())).find('.sold__img').remove();
      });    
    }

    function selectProdVariant(){
      if($(this).parent().hasClass('outofstock')){
        return;
      }
       sizeArr = [];
       quantityArr = [];
       var selectedVariant = ($(this).val());
       var selectedOption = ($(this).attr('data-option'));
       if(selectedOption == "Quantity"){
        for(var i = 0; i < availableArray.length; i++){
          if((availableArray[i].title).includes(selectedVariant) && (availableArray[i].title).includes(selectedColor)){
            sizeArr.push(availableArray[i].option2)
          }
        }
         sizeArr = uniqueArray(sizeArr);
         $('.Size').removeClass("instock").addClass("outofstock");
         $('.Size').find('.sold__img').remove();
         $('.Size').find('.SizeSwatch').append('<img class="sold__img" src="//cdn.shopify.com/s/files/1/0407/0906/2822/t/7/assets/cross-out.png" alt="Sold Out">')
         $.each(sizeArr,function(i,v){
           $('.variant-'+(sizeArr[i].toLowerCase())).removeClass('outofstock').addClass("instock");
           $('.variant-'+(sizeArr[i].toLowerCase())).find('.sold__img').remove();
         });
       }
       if(selectedOption == "Size"){
        for(var i = 0; i < availableArray.length; i++){
          if((availableArray[i].title).includes(selectedVariant) && (availableArray[i].title).includes(selectedColor)){
            quantityArr.push(availableArray[i].option3)
          }
        }
         quantityArr = uniqueArray(quantityArr);
         $('.Quantity').removeClass("instock").addClass("outofstock");
         $('.Quantity').find('.sold__img').remove();
         $('.Quantity').find('.SizeSwatch').append('<img class="sold__img" src="//cdn.shopify.com/s/files/1/0407/0906/2822/t/7/assets/cross-out.png" alt="Sold Out">')
         $.each(quantityArr,function(i,v){
           $('.variant-'+(quantityArr[i].split(' ').join('-').toLowerCase())).removeClass('outofstock').addClass("instock");
           $('.variant-'+(quantityArr[i].split(' ').join('-').toLowerCase())).find('.sold__img').remove();
         });
       }      
    }

    function uniqueArray(getArray){
      var newArray = []
       $.each(getArray, function(i, el){
          if($.inArray(el, newArray) === -1) newArray.push(el);
      }); 
      return newArray;
    }
  
    $('.service_sticky li').click(function(e)
	{
       e.stopPropagation();
      if($(this).attr('data-block') == 'sticky')
      {
		$('.service_sticky li').attr('data-block','');
        $('.service_sticky li').removeClass('sticky_active');
        $('.service_sticky li').find('div').removeClass('sticky_content');
        $('.service_sticky li').find('.sticky-bar_inner').hide();
      }
      else
      {
        $('.service_sticky li').attr('data-block','');
        $('.service_sticky li').find('div').removeClass('sticky_content');
        $('.service_sticky li').removeClass('sticky_active');
        $(this).find('div').addClass('sticky_content');
        $(this).attr('data-block','sticky');
        $(this).addClass('sticky_active');
      	$('.sticky-bar_inner').hide();
        $(this).find('.sticky-bar_inner').show();  
      }
    })
    
    $('.sticky-bar_inner').click(function(e)
	{
            e.stopPropagation();
    });
  
  	$(document).click(function(e)
	{
     e.stopPropagation();
      $('.sticky-bar_inner').each(function()
      {
        if($(this).is(":visible"))
          {
            $(this).hide();
          }
      })
	  $('.service_sticky li').attr('data-block','');
      $('.service_sticky li').removeClass('sticky_active');
      
  })
     //update clr values:
    
    $('.HorizontalList li').click(function(){
      var _getclass = $(this).parent().parent().parent().find('.Swatch__Container').attr('class').split(' ')[1];
      var ids= $(this).find('input[type="radio"]').attr('data-option');
      $('.showopt_'+ids).find('span').html($(this).find('input[type="radio"]').val());  
       setTimeout(function(){
      if($('.ProductForm__AddToCart').attr('disabled') == 'disabled'){
        $('.shipping-badge span').hide();
      	$('.-available').hide();
        $('.-sold-out:first').show();
        
      }
      else{
       $('.shipping-badge span').hide();
       $('.-sold-out').hide();
        $('.-available:first').show();
      }
      showPreOrderText();
      },400);
    })
  });

  function showPreOrderText(){
    var getVariantId = $('.productVariantOptions').val();
    var getVariantAvail = $('.variant-id-'+getVariantId).attr('data-variant-available');
    var getVariantQuantity = $('.variant-id-'+getVariantId).attr('data-inventry-quantity');
    var getVariantPolicy = $('.variant-id-'+getVariantId).attr('data-inventry-policy');
    if(getVariantAvail && getVariantQuantity <= 0 && getVariantPolicy == "continue"){
      $('.-available,.-sold-out').hide();
      $('.-preOrder:first').show();
    }
  }

// Accordion Pannel
$(".Accordion__Pannel").hide();
  $(".Accordion__Pannel:first").show(); // THIS LINE IS ADDED!!!
  $("Accordion__Trigger:first").addClass("current");
  $(".Accordion__Trigger").click(function(){
  if ($(this).is(".current")) {
    $(this).removeClass("current");
    $(this).next(".Accordion__Pannel").slideUp(400);
  } else {
    $(".Accordion__Pannel").slideUp(400);
    $(".Accordion__Trigger").removeClass("current");
    $(this).addClass("current");
    $(this).next(".Accordion__Pannel").slideDown(400);
  }
   
});

// Tab
$(function() {
  $('.tabs-nav a').click(function() {

    // Check for active
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');

    // Display active tab
    let currentTab = $(this).attr('href');
    $('.tabs-content .tab-panel').hide();
    $(currentTab).show();

    return false;
  });
});
  

/*var productJson = document.getElementById('ProductJson-product-template');
    if (!productJson || !productJson.innerHTML.length) {
    
 }
var productSingle = JSON.parse(productJson.innerHTML);
productVariants=productSingle.product.variants;


var radios = document.querySelectorAll('input[type=radio]');
radios.forEach(radio => radio.addEventListener('change', () => selectedRadioValue(radio.value, radio.getAttribute('data-opt'))));

function selectedRadioValue(value,option){
  
console.log(productVariants[0].option1,'vals',value,option);  
  
  if(option == "option-0"){
    var elems = document.querySelectorAll(".SizeSwatchList li");
    [].forEach.call(elems, function(el) {
      el.classList.remove("instock");
    });
    var elems = document.querySelectorAll(".SizeSwatchList li");
    [].forEach.call(elems, function(el) {
      el.classList.remove("outofstock");
    });
  }else if(option == "option-1"){
    var elems = document.querySelectorAll(".ColorSwatchList li");
    [].forEach.call(elems, function(el) {
      el.classList.remove("instock");
    });
    var elems = document.querySelectorAll(".ColorSwatchList li");
    [].forEach.call(elems, function(el) {
      el.classList.remove("outofstock");
    });
  }
  for(let i=0; i<=productVariants.length; i++){
    if(productVariants[i].option1 == value && option == "option-0"){
      var option0 = document.querySelector("input[name='option-0']:checked").getAttribute("data-variant");
      var string = productVariants[i].option2;
      string=string.toLowerCase();
      var handle = string.replace(/-|\s/g,"-");
      if(productVariants[i].available == false){
        document.querySelector("."+string).classList.add('outofstock');
      }else{
         document.querySelector("."+string).classList.add('instock');        
      }      
    }else if(productVariants[i].option2 == value && option =="option-1"){
      var option0 = document.querySelector("input[name='option-1']:checked").getAttribute("data-variant");
      var string = productVariants[i].option1;
      string=string.toLowerCase();
      var handle = string.replace(/-|\s/g,"-");
      if(productVariants[i].available == false){
        document.querySelector("."+string).classList.add('outofstock');
      }else{
         document.querySelector("."+string).classList.add('instock');        
      } 
    }
  }
}*/

  function drawerCartClose(){
    $('[data-action="close-drawer"]').trigger('click');
  }

$(document).ready(function(){
  
  var clickedTimeout = setTimeout(function(){
  	$('.closeCartChild').off('click').on('click',drawerCartClose);
    clearTimeout(clickedTimeout);
  },3000);
  
  $('.tabs-nav li a').click(function(){
  	
    var $carousel = $('.ProductTabList').flickity();
     $carousel.show()
    // trigger resize method after showing
    .flickity('resize');
  })
  
});

$('.ProductTabList').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  groupCells: true,
  pageDots: false
});


$(document).ready(function(){
  $(".image-slider").owlCarousel({
    center: true,
    loop:true,
    margin:10,
    nav:true,
    dots:false,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:4
        },
        1000:{
            items:6
        }
    }
  });
});

